import { render } from "./PpidList.vue?vue&type=template&id=60749f88"
import script from "./PpidList.vue?vue&type=script&lang=js"
export * from "./PpidList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__